import { render, staticRenderFns } from "./GameWx4.vue?vue&type=template&id=7ae02998&scoped=true&"
import script from "./GameWx4.vue?vue&type=script&lang=js&"
export * from "./GameWx4.vue?vue&type=script&lang=js&"
import style0 from "./GameWx4.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameWx4.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameWx4.vue?vue&type=style&index=2&id=7ae02998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae02998",
  null
  
)

export default component.exports